// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-9ffb5e3a]{height:3rem;margin:0 .75rem -.3rem 0;padding:0}@media screen and (min-width:40.063em)and (max-width:64em){.blog-container[data-v-9ffb5e3a]{padding:0 3.75rem}}@media screen and (max-width:32em){.section-resources-list[data-v-9ffb5e3a]{padding:0 3rem}header[data-v-9ffb5e3a]{padding:2.5rem 3rem 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
